

import React, { useState , useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { MdDashboard } from "react-icons/md";
import { FaUsers, FaAngleLeft, FaAngleRight ,FaPlus } from "react-icons/fa";
import { BiLogOut } from "react-icons/bi";
import { IoCart } from "react-icons/io5";
import { IoMdPersonAdd } from "react-icons/io";
import { IoSettings } from "react-icons/io5";
import { FaTruckField } from "react-icons/fa6";
import { FaTractor } from "react-icons/fa6";
import { TbReportMoney } from "react-icons/tb";
import { FaSearchDollar } from "react-icons/fa";
import { TbSettingsSearch } from "react-icons/tb";
import { GiWallet } from "react-icons/gi";
import { MdSupportAgent } from "react-icons/md";
import { MdLocationOn } from "react-icons/md";
import { BiSolidCategory } from "react-icons/bi";
import { TbShoppingCartUp } from "react-icons/tb";
import { FaQuestionCircle } from "react-icons/fa";
import { MdQuestionAnswer } from "react-icons/md";
import { RiFeedbackFill } from "react-icons/ri";
import { BiSolidCategoryAlt } from "react-icons/bi";

function AdminSideBar({ collapsed, setCollapsed }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [showLogoutModal, setShowLogoutModal] = useState(false);


  const handleLogout = () => {
    localStorage.removeItem("isAdmin");
    localStorage.removeItem("userData");
    navigate("/admin-login");
    window.location.reload();
  };


  useEffect(() => {
  const handleResize = () => {
    if (window.innerWidth <= 768) {
      setCollapsed(true);
    }
  };

  handleResize(); // Run on first load

  window.addEventListener("resize", handleResize);

  return () => window.removeEventListener("resize", handleResize);
}, [setCollapsed]);

const handleNavigation = (path) => {
  navigate(path);

  if (window.innerWidth <= 768) {
    setCollapsed(true);
  }
};

  return (
    <div
      className={`sidebar ${collapsed ? "collapsed" : ""}`}
      style={{
        // height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >

      {/* TOP SECTION */}
      <div>

        {/* HEADER */}
        {/* <div className="sidebar-header d-flex justify-content-between align-items-center p-2">

        
          {!collapsed && <h5 className="m-0"> <img
    src="/krimotion logo.jpeg"
    alt="Krimotion Logo"
    width="70"
    height="70"
    className="me-2"
  /> 
   </h5>}

          <span
            className="sidebar-item py-2 px-3"
            onClick={() => setCollapsed(!collapsed)}
            style={{ cursor: "pointer" }}
          >
            {collapsed ? (
              <FaAngleRight size={22} />
            ) : (
              <FaAngleLeft size={22} />
            )}
          </span>

        </div> */}

        <div className="sidebar-header d-flex align-items-center justify-content-between p-3 border-bottom">
           {!collapsed && (
    <div className="d-flex align-items-center">
      <img
        src="/krimotion_logo.jpeg"
        alt="Krimotion Logo"
        width="45"
        height="45"
        className="rounded me-2"
      />

      <div>
        <h5 className="mb-0 fw-bold">
          <span style={{ color: "var(--primary-color)" }}>K</span>RIMOTION
        </h5>
        <small className="text-muted">Admin Panel</small>
      </div>
    </div>
  )}



  <button
    className="btn btn-light btn-sm rounded-circle"
    onClick={() => setCollapsed(!collapsed)}
  >
    {collapsed ? (
      <FaAngleRight size={18} />
    ) : (
      <FaAngleLeft size={18} />
    )}
  </button>
        </div>

        {/* MENU */}
        <ul className="sidebar-menu list-unstyled p-2">

          <li
            className={`sidebar-item ${
              location.pathname.includes("admin-dashboard") ? "active" : ""
            }`}
            onClick={() => navigate("/admin/admin-dashboard")}
            style={{ cursor: "pointer" }}
          >
            <MdDashboard size={20} />
            {!collapsed && <span className="ms-2">Dashboard</span>}
          </li>

               <li
            className={`sidebar-item ${
              location.pathname.includes("inventory") ? "active" : ""
            }`}
            onClick={() => navigate("/admin/inventory")}
            style={{ cursor: "pointer" }}
          >
            <IoCart size={20} />
            {!collapsed && <span className="ms-2">Inventory</span>}
          </li>

          <li
            className={`sidebar-item ${
              location.pathname.includes("dealers") ? "active" : ""
            }`}
          onClick={() => handleNavigation("/admin/dealers")}
            style={{ cursor: "pointer" }}
          >
            <FaUsers size={20} />
            {!collapsed && <span className="ms-2">Dealers</span>}
          </li>

           <li
            className={`sidebar-item ${
              location.pathname.includes("user") ? "active" : ""
            }`}
            onClick={() => navigate("/admin/users")}
            style={{ cursor: "pointer" }}
          >
            <IoMdPersonAdd size={20} />
            {!collapsed && <span className="ms-2">User</span>}
          </li>

   <li
            className={`sidebar-item ${
              location.pathname.includes("driver") ? "active" : ""
            }`}
            onClick={() => navigate("/admin/driver")}
            style={{ cursor: "pointer" }}
          >
            <FaTruckField size={20} />
            {!collapsed && <span className="ms-2">Driver</span>}
          </li>

          <li
            className={`sidebar-item ${
              location.pathname.includes("machine-list") ? "active" : ""
            }`}
            onClick={() => navigate("/admin/machine-list")}
            style={{ cursor: "pointer" }}
          >
            <FaTractor size={20} />
            {!collapsed && <span className="ms-2">Vehicle List</span>}
          </li>


            {/* <li
            className={`sidebar-item ${
              location.pathname.includes("enquiry") ? "active" : ""
            }`}
            onClick={() => navigate("/admin/enquiry")}
            style={{ cursor: "pointer" }}
          >
            <TbReportMoney size={20} />
            {!collapsed && <span className="ms-2">Driver Enquiry</span>}
          </li> */}

                  <li
            className={`sidebar-item ${
              location.pathname.includes("customer-enq") ? "active" : ""
            }`}
            onClick={() => navigate("/admin/customer-enq")}
            style={{ cursor: "pointer" }}
          >
            <FaSearchDollar size={20} />
            {!collapsed && <span className="ms-2">Machine Enquiry</span>}
          </li>


       <li
            className={`sidebar-item ${
              location.pathname.includes("customer-sphere") ? "active" : ""
            }`}
            onClick={() => navigate("/admin/customer-sphere")}
            style={{ cursor: "pointer" }}
          >
            <TbSettingsSearch size={20} />
            {!collapsed && <span className="ms-2">Parts Enquiry</span>}
          </li>


             <li
            className={`sidebar-item ${
              location.pathname.includes("withdrawal") ? "active" : ""
            }`}
            onClick={() => navigate("/admin/withdrawal")}
            style={{ cursor: "pointer" }}
          >
            <GiWallet size={20} />
            {!collapsed && <span className="ms-2">Driver Withdrawal</span>}
          </li>

                <li
            className={`sidebar-item ${
              location.pathname.includes("walltet") ? "active" : ""
            }`}
            onClick={() => navigate("/admin/walltet")}
            style={{ cursor: "pointer" }}
          >
            <GiWallet size={20} />
            {!collapsed && <span className="ms-2">Dealer Withdrawal</span>}
          </li>

                {/* <li
            className={`sidebar-item ${
              location.pathname.includes("return") ? "active" : ""
            }`}
            onClick={() => navigate("/admin/return")}
            style={{ cursor: "pointer" }}
          >
            <TbShoppingCartUp size={20} />
            {!collapsed && <span className="ms-2">Return Item</span>}
          </li> */}

               <li
            className={`sidebar-item ${
              location.pathname.includes("master") ? "active" : ""
            }`}
            onClick={() => navigate("/admin/master")}
            style={{ cursor: "pointer" }}
          >
            <MdLocationOn size={20} />
            {!collapsed && <span className="ms-2">Pincode Master</span>}
          </li>

      <li
            className={`sidebar-item ${
              location.pathname.includes("business") ? "active" : ""
            }`}
            onClick={() => navigate("/admin/business")}
            style={{ cursor: "pointer" }}
          >
            <BiSolidCategoryAlt size={20} />
            {!collapsed && <span className="ms-2">Business Category Master</span>}
          </li>

              <li
            className={`sidebar-item ${
              location.pathname.includes("category") ? "active" : ""
            }`}
            onClick={() => navigate("/admin/category")}
            style={{ cursor: "pointer" }}
          >
            <BiSolidCategory size={20} />
            {!collapsed && <span className="ms-2">Category Master</span>}
          </li>


              <li
            className={`sidebar-item ${
              location.pathname.includes("question") ? "active" : ""
            }`}
            onClick={() => navigate("/admin/question")}
            style={{ cursor: "pointer" }}
          >
            <FaQuestionCircle size={20} />
            {!collapsed && <span className="ms-2">Question Master</span>}
          </li>

                <li
            className={`sidebar-item ${
              location.pathname.includes("suggestion") ? "active" : ""
            }`}
            onClick={() => navigate("/admin/suggestion")}
            style={{ cursor: "pointer" }}
          >
            <RiFeedbackFill size={20} />
            {!collapsed && <span className="ms-2">Chatbot Suggestion</span>}
          </li>

          

              <li
            className={`sidebar-item ${
              location.pathname.includes("banner") ? "active" : ""
            }`}
            onClick={() => navigate("/admin/banner")}
            style={{ cursor: "pointer" }}
          >
            <IoSettings size={20} />
            {!collapsed && <span className="ms-2">Setting</span>}
          </li>


               <li
            className={`sidebar-item ${
              location.pathname.includes("help-support") ? "active" : ""
            }`}
            onClick={() => navigate("/admin/help-support")}
            style={{ cursor: "pointer" }}
          >
            <MdSupportAgent size={20} />
            {!collapsed && <span className="ms-2">Help & Support</span>}
          </li>


                  <li
            className={`sidebar-item ${
              location.pathname.includes("web-query") ? "active" : ""
            }`}
            onClick={() => navigate("/admin/web-query")}
            style={{ cursor: "pointer" }}
          >
            <FaSearchDollar size={20} />
            {!collapsed && <span className="ms-2">Web Enquiry</span>}
          </li>

           

        </ul>


           
   

      </div>

   
    <div className="p-2">

  <div
    className={`sidebar-item d-flex align-items-center ${
      collapsed ? "justify-content-center" : ""
    }`}
    // onClick={handleLogout}
    onClick={() => setShowLogoutModal(true)}
    style={{
      cursor: "pointer",
      color: "#fff",
      background: "linear-gradient(135deg, #dc3545, #b02a37)",
      borderRadius: "10px",
      padding: "10px",
      boxShadow: "0 4px 10px rgba(220,53,69,0.3)",
      transition: "0.3s",
    }}
  >
    <BiLogOut size={20} />


    {!collapsed && <span className="ms-2">Logout</span>}
  </div>

</div>

<div
  className={`modal fade ${showLogoutModal ? "show d-block" : ""}`}
  tabIndex="-1"
  role="dialog"
>
  <div className="modal-dialog modal-dialog-centered" role="document">
    <div className="modal-content border-0 shadow-lg rounded-4">

      {/* Header */}
      <div className="modal-header bg-danger text-white">
        <h5 className="modal-title d-flex align-items-center gap-2">
          ⚠️ Confirm Logout
        </h5>
        <button
          type="button"
          className="btn-close btn-close-white"
          onClick={() => setShowLogoutModal(false)}
        ></button>
      </div>

      {/* Body */}
      <div className="modal-body text-center py-4">

        <div className="mb-3">
          <div className="display-6">👋</div>
        </div>

        <h5 className="mb-2">Are you sure you want to logout?</h5>

        <p className="text-muted mb-0">
          You will need to login again to access the admin dashboard.
        </p>

      </div>

      {/* Footer */}
      <div className="modal-footer border-0 justify-content-center gap-2 pb-4">

        <button
          className="btn btn-light px-4"
          onClick={() => setShowLogoutModal(false)}
        >
          Cancel
        </button>

        <button
          className="btn btn-danger px-4 d-flex align-items-center gap-2"
          onClick={() => {
            setShowLogoutModal(false);
            handleLogout();
          }}
        >
          Logout
        </button>

      </div>

    </div>
  </div>
</div>

    </div>
  );
}

export default AdminSideBar;